import React from 'react';
import {constants} from '@neosvoc/nv-platform-core-common';
import LogicOp from './LogicOp';
import StringBuilder from './builders/StringBuilder';
import ChoiceBuilder from './builders/ChoiceBuilder';
import NumberBuilder from './builders/NumberBuilder';
import MultipleNumberBuilder from './builders/MultipleNumberBuilder';
import MultipleChoiceBuilder from './builders/MultipleChoiceBuilder';
import DateBuilder from './builders/DateBuilder';
import BatteryBuilder from './builders/BatteryBuilder';
import ParameterBuilder from './builders/ParameterBuilder';

class Expression extends React.Component {
    constructor(props) {
        super(props);
    }

    renderExpression(item, expression, param, extraField) {
        if (param) {
            return <ParameterBuilder expression={expression} item={param} />;
        }
        if (extraField) {
            return <ParameterBuilder expression={expression} item={extraField} />;
        }
        switch (item.type) {
            case constants.EDITOR_TEMPLATES.STRING_1:
                return <StringBuilder expression={expression} />;
            case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1:
            case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_2:
            case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_3:
            case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_4:
            case constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER:
            case constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER_2:
                return <ChoiceBuilder expression={expression} />;
            case constants.EDITOR_TEMPLATES.NUMBER_1:
            case constants.EDITOR_TEMPLATES.NUMBER_2:
            // case constants.EDITOR_TEMPLATES.RANK_1:
                return <NumberBuilder expression={expression} />;
            case constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_1:
            case constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_2:
            case constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_3:
            case constants.EDITOR_TEMPLATES.RANK_1:
                return <MultipleNumberBuilder expression={expression} />;
            case constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_1:
            case constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_2:
                return <MultipleChoiceBuilder expression={expression} />;
            case constants.EDITOR_TEMPLATES.DATE_1:
                return <DateBuilder expression={expression} />;
            case constants.EDITOR_TEMPLATES.BATTERY_1:
                return <BatteryBuilder expression={expression} />;
            case constants.EDITOR_TEMPLATES.BATTERY_2:
                return <MultipleChoiceBuilder expression={expression} />;
        }
    }

    render() {
        const {expression, items, logicOp, parameters, extraFields} = this.props;
        const item = items.find((item) => item.id === expression.id);
        const param = parameters && parameters.find((p) => `parameters.${p.name}` === expression.id);
        const extraField = extraFields && extraFields.find((f) => `extraFields.${f.name}` === expression.id);
        if (!item && !param && !extraField) {
            return null;
        }

        if (logicOp) {
            return (
                <>
                    {this.renderExpression(item, expression, param, extraField)}
                    <LogicOp operator={expression.logicOp} />
                </>
            );
        } else {
            return (
                <>
                    {this.renderExpression(item, expression, param, extraField)}
                </>
            );
        }
    }
}

export default Expression;
